import { createContext } from 'react';

export const LangContext = createContext();   
export const SponsorContext = createContext(); 
export const PostContext = createContext();
export const MenuContext = createContext();
export const SetupContext = createContext();
export const TimeZoneContext = createContext(); 
export const SessionContext = createContext();
export const BiographyContext = createContext();
export const SocialEventContext = createContext();